import debug from 'debug';
import Swiper from 'swiper/bundle';
import tilbageRenSvg from 'Minetilbud/Shared/Icons/tilbage_ren.svg';
import fremRenSvg from 'Minetilbud/Shared/Icons/frem_ren.svg';
import Behaviour from '../static/behaviour';

const log = debug('BoostBanner:Render:SitecoreItems');

class SitecoreItems {
	constructor(element, dom, settings) {
		this.element = element;
		this.dom = dom;
		this.settings = settings;

		this.bannerReadyEvent = this.bannerReadyHandler.bind(this);

		this.initialize();
	}

	bannerReadyHandler() {
		let bannerReady = true;
		Array.from(this.dom.wrapper.children).forEach(childElement => {
			if (childElement.classList.contains('banner-ready') === false) {
				bannerReady = false;
			}
		});

		if (bannerReady) {
			this.render();
		}
	}

	eventListeners() {
		document.addEventListener(Behaviour.eventKeys.bannerReady, this.bannerReadyEvent, false);
	}

	/**
	 * @returns {Object} settings
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	initialize() {
		this.setup();
		this.eventListeners();
		this.bannerReadyHandler();
	}

	render() {
		if (this.swiper) {
			this.swiper.destroy();
		}
		this.swiper = new Swiper(this.element, this.options);
		this.element.classList.remove('is-loading');
	}

	setup() {
		this.element.classList.add('swiper-container');
		this.dom.wrapper.classList.add('swiper-wrapper');

		[...this.dom.wrapper.children].map(child => {
			child.classList.add('swiper-slide');
		});

		this.options = {
			speed: this.settings.speed,
			loop: this.settings.loop,
		}

		const slideCount = this.dom.wrapper.children.length;
		if (slideCount < 2) return;

		this.dom.buttonNext.classList.add('o-boost-banner__button-next');
		this.dom.buttonNext.insertAdjacentHTML('beforeend', fremRenSvg);

		this.dom.buttonPrev.classList.add('o-boost-banner__button-prev');
		this.dom.buttonPrev.insertAdjacentHTML('beforeend', tilbageRenSvg);

		this.options = {
			speed: this.settings.speed,
			loop: this.settings.loop,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				bulletClass: 'o-boost-banner__bullet',
				bulletActiveClass: 'o-boost-banner__bullet--active'
			},
			navigation: {
				nextEl: '.o-boost-banner__button-next',
				prevEl: '.o-boost-banner__button-prev'
			}
		}

		if (this.settings.autoStart) {
			this.options = {
				slidesPerView: 1,
				speed: this.settings.speed,
				loop: this.settings.loop,
				autoplay: {
					delay: this.settings.delay
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
					bulletClass: 'o-boost-banner__bullet',
					bulletActiveClass: 'o-boost-banner__bullet--active'
				},
				navigation: {
					nextEl: '.o-boost-banner__button-next',
					prevEl: '.o-boost-banner__button-prev'
				}
			}
		}
	}
}

export default SitecoreItems;
